import type { TaskResult } from "../types";

export async function gradeProject4(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  // Tarea 1: Segmentación de datos con solo "Brasil" seleccionado
  await Excel.run(async (context) => {
    const hoja = context.workbook.worksheets.getItem("Exportaciones de Grano");
    const slicers = hoja.slicers;
    slicers.load("items/name");
    await context.sync();

    for (const sl of slicers.items) {
      sl.slicerItems.load("name,isSelected");
    }
    await context.sync();

    let cumple = false;
    for (const sl of slicers.items) {
      const activos = sl.slicerItems.items.filter((i) => i.isSelected);
      if (
        activos.length === 1 &&
        activos[0].name.trim().toLowerCase() === "brasil"
      ) {
        cumple = true;
        break;
      }
    }
    results.push({ taskId: 1, passed: cumple });
  });

  // Tarea 2: Emails en C3:C34 con Flash Fill
  await Excel.run(async (context) => {
    const hoja = context.workbook.worksheets.getItem("Departamento de Ventas");
    const rang = hoja.getRange("C3:C34");
    rang.load("values");
    await context.sync();

    const esperados = [
      "hart.sam@fusiontomo.com",
      "finney.mike@fusiontomo.com",
      "barlow.kevin@fusiontomo.com",
      "noakes.sheila@fusiontomo.com",
      "riley.steve@fusiontomo.com",
      "webster.dan@fusiontomo.com",
      "moorefield.eva@fusiontomo.com",
      "doran.john@fusiontomo.com",
      "flint.cheryl@fusiontomo.com",
      "shea.jessie@fusiontomo.com",
      "oppenhoff.greg@fusiontomo.com",
      "cramer.chris@fusiontomo.com",
      "silman.stan@fusiontomo.com",
      "franklin.deann@fusiontomo.com",
      "nguen.yuan@fusiontomo.com",
      "gbedemah.kofi@fusiontomo.com",
      "juarez.juanita@fusiontomo.com",
      "sanchez.timo@fusiontomo.com",
      "braun.christof@fusiontomo.com",
      "perez.bridgette@fusiontomo.com",
      "bahn.chris@fusiontomo.com",
      "stephan.pierre@fusiontomo.com",
      "yamashita.jan@fusiontomo.com",
      "white.brent@fusiontomo.com",
      "brown.samuel@fusiontomo.com",
      "chu.jen@fusiontomo.com",
      "martinez.rosie@fusiontomo.com",
      "larose.haley@fusiontomo.com",
      "kramer.logan@fusiontomo.com",
      "watson.von@fusiontomo.com",
      "doucette.nicole@fusiontomo.com",
      "clauss.nickaus@fusiontomo.com",
    ];

    const reales = rang.values.flat().map((v) => String(v).toLowerCase());
    const passed =
      reales.length === esperados.length &&
      reales.every((v, i) => v === esperados[i]);
    results.push({ taskId: 2, passed });
  });

  // Tarea 3: DIA.LAB en B6 → =WORKDAY(B3,B4,B5)
  await Excel.run(async (context) => {
    const hoja = context.workbook.worksheets.getItem("Calculadora de Envío");
    const cel = hoja.getRange("B6");
    cel.load("formulas");
    await context.sync();

    const formula = (cel.formulas[0][0] || "").toUpperCase();
    results.push({ taskId: 3, passed: formula === "=WORKDAY(B3,B4,B5)" });
  });

  // Tarea 4: NPER en B8 → ~130 meses
  await Excel.run(async (context) => {
    const hoja = context.workbook.worksheets.getItem("Calculadora de Pago");
    const cel = hoja.getRange("B8");
    cel.load("formulas,values");
    await context.sync();

    const formulaOk = (cel.formulas[0][0] || "").toUpperCase().includes("NPER");
    const valor = Number(cel.values[0][0]);
    const valorOk = Math.abs(valor - 130) <= 1;
    results.push({ taskId: 4, passed: formulaOk && valorOk });
  });

  // Tarea 5: Tabla dinámica con País en filas y Toneladas en valores
  await Excel.run(async (context) => {
    const sheets = context.workbook.worksheets;
    sheets.load("items/name");
    await context.sync();

    for (const ws of sheets.items) {
      const pivots = ws.pivotTables;
      pivots.load(
        "items/rowHierarchies/items/name,items/dataHierarchies/items/name"
      );
    }
    await context.sync();

    let esCorrecto = false;
    for (const ws of sheets.items) {
      for (const pt of ws.pivotTables.items) {
        const filas = pt.rowHierarchies.items.map((h) => h.name.toLowerCase());
        const valores = pt.dataHierarchies.items.map((h) =>
          h.name.toLowerCase()
        );
        const tienePais = filas.some(
          (n) => n.includes("país") || n.includes("country")
        );
        const tieneTm = valores.some(
          (n) => n.includes("toneladas") || n.includes("metric")
        );
        if (tienePais && tieneTm) {
          esCorrecto = true;
          break;
        }
      }
      if (esCorrecto) break;
    }
    results.push({ taskId: 5, passed: esCorrecto });
  });

  return results;
}
